"use client";

import { SYMBOL_IMAGES, defaultCardDates } from "@/app/components/appcomponents/thankYouCard";

// What the sample cards show before a memory page has been picked.
const SAMPLE = { name: "Mario Danilo", sirName: "Primo", city: "Ljubljana", symbol: "1" };
const SAMPLE_DATES = "1948 – 29.01.2024";
const SAMPLE_AGE = " (76 let)";

/**
 * The two sample cards of the "Poudarjena osmrtnica" popup, drawn to the client's measurements (not the site's
 * obituary card, which has its own rules). Phone (up to 742px): the candle picture, name in bold, the quiet line "Za
 * vedno v naših srcih", no religious sign. Tablet / desktop: a portrait, the age, the sign in the free corner, no line.
 * `obituary` is the page the visitor picked (its own data), or nothing for the sample.
 */
export default function SampleObituaryCard({ obituary = null, highlighted = false }) {
  const o = obituary || SAMPLE;
  const symbol = SYMBOL_IMAGES[o.symbol]?.src;
  const dates = obituary ? defaultCardDates(obituary) : SAMPLE_DATES;
  const age = obituary ? "" : SAMPLE_AGE;
  const place = o.city || o.location || "";
  const candle = "/user5.jpeg";

  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none relative h-[170px] w-full rounded-[8px] mobile:h-[127px] mobile:rounded-[6px] ${
        highlighted ? "shadow-md" : "border border-white bg-gradient-to-br from-[#E3EAEF] to-[#F3F6F8] shadow-custom-light-dark-box"
      }`}
      style={
        highlighted ?
          { background: "linear-gradient(#F6EEDD, #F6EEDD) padding-box, linear-gradient(135deg, #1D8CC2, #5A18C8) border-box", border: "2px solid transparent" }
        : undefined
      }
    >
      {/* picture in its white frame, vertically in the middle */}
      <span className="absolute left-[16px] top-[15px] rounded-xl bg-gradient-to-br from-[#E3E8EC] to-white p-1 shadow-custom-light-dark-box-image mobile:left-[20px] mobile:top-[10px]">
        {/* the picked page's own photo; before one is picked the neutral candle picture (never a made-up person) */}
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={obituary?.image || candle} alt="" className="block h-[130px] w-[95px] rounded-lg object-cover mobile:h-[96px] mobile:w-[70px]" />
      </span>

      <div className="absolute left-[138px] right-[62px] top-[24px] text-[#1E2125] mobile:left-[118px] mobile:right-[12px] mobile:top-[14px]">
        <p className="truncate text-[18px] leading-[24px] mobile:text-[16px] mobile:font-semibold mobile:leading-[20px]">
          {o.name} {o.sirName}
        </p>
        <p className="mt-[22px] truncate text-[13px] leading-[20px] text-[#414141] mobile:mt-[15px] mobile:text-[14px] mobile:leading-[18px]">
          {dates}
          <span className="mobile:hidden">{age}</span>
        </p>
        <p className="mt-[6px] truncate text-[13px] leading-[20px] text-[#414141] mobile:mt-0 mobile:text-[14px] mobile:leading-[18px]">{place}</p>
      </div>

      {/* tablet / desktop: the religious sign in the free corner */}
      {symbol && <img src={symbol} alt="" className="absolute right-[14px] top-[24px] h-[52px] w-[42px] mobile:hidden" />}

      {/* phone: the quiet line, so that all the attention goes to the card itself */}
      <p className="absolute bottom-[12px] right-[14px] hidden font-greatVibes text-[15px] leading-[20px] text-[#414B5A]/80 mobile:block">
        Za vedno v naših srcih
      </p>
    </div>
  );
}
